// `_contains` : a collection's function
// --------------------------------------

// The cornerstone, a `contains` implementation, aka `include`.
export {default} from './include';